'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var Bacon, Dispatcher, R, _addAddress, addAddressStream, addDistance, addressToPosition, addressesSvcURL, _autoLogin, availableAddressesStream, browser, channelStream, d, defaultPosition, errorsStream, executeAction, geoStore, integrationStore, isMobilePhone, isUserValid, isUserValidOnLocale, loadAddresses, loadUser, makeErrorIfNull, newUser, onlyNumbers, portalStore, profileValidationErrors, reloadAddresses, resUtil, restaurantStore, storage, toError, _updateProfile, userKey, userLoadedStream, userProps, userStream, userStreamData, userURL, validProfileStream, validate, validateUser, validateUserOnLocale, validateUserProp, validateUserPropOnLocale, validator;

Bacon = require('baconjs');

R = require('ramda');

Dispatcher = require('../utils/dispatcher');

resUtil = require('../utils/resources');

storage = require('../utils/storage');

integrationStore = require('./integration');

restaurantStore = require('./restaurant');

portalStore = require('./portal');

browser = require('../utils/browser');

validator = require('validator');

d = new Dispatcher('user');

makeErrorIfNull = function makeErrorIfNull(res) {
  if (res) {
    return new Bacon.Next(res);
  } else {
    return new Bacon.Error(null);
  }
};

geoStore = require('./address');

channelStream = portalStore.channel.skipDuplicates(R.equals);

userKey = function userKey(channel_id) {
  return 'USER0D#' + channel_id;
};

// ---- new user api
userURL = d.stream('restore-user-url').map(userKey).flatMap(storage.getItem('user'));

loadUser = d.stream('load-user').flatMap(resUtil.loadResourceFromURL).map(R.prop('user'));

newUser = d.stream('create-user').map(resUtil.findResourceLink('users', 'post')).map(R.assoc('url', R.__, {})).map(R.assoc('integration_url', R.defaultTo('zuppler-mobile://homeView', resUtil.integrationUrl()))).flatMap(resUtil.createResource).map(R.prop('user'));

_updateProfile = d.stream('profile').flatMap(resUtil.updateResource).map(R.prop('user'));

_autoLogin = d.stream('auto-login').flatMap(resUtil.createResource).map(R.prop('user'));

userStreamData = Bacon.update({
  channel: null,
  url: null,
  user: null
}, [channelStream.toEventStream()], function (prev, channel) {
  d.stream('restore-user-url').push(channel.id);
  return { channel: channel };
}, [d.stream('reload-user')], function (prev, _) {
  d.stream('load-user').push(prev.url);
  return prev;
}, [userURL], function (_ref, url) {
  var channel = _ref.channel;

  if (url) {
    d.stream('load-user').push(url);
  } else {
    d.stream('create-user').push(channel);
  }
  return { channel: channel, url: url };
}, [newUser], function (_ref2, user) {
  var channel = _ref2.channel;

  d.stream('save-user-url').push({
    url: user.resource_url,
    key: channel.id
  });
  return {
    channel: channel,
    url: user.resource_url,
    user: user
  };
}, [loadUser], function (_ref3, user) {
  var channel = _ref3.channel,
      url = _ref3.url;

  return { channel: channel, url: url, user: user };
}, [loadUser.errors()], function (prev, err) {
  return d.stream('create-user').push(prev.channel);
}, [_autoLogin.skipErrors()], function (_ref4, user) {
  var channel = _ref4.channel,
      url = _ref4.url;

  return { channel: channel, url: url, user: user };
}, [d.stream('save-profile')], function (_ref5, profile) {
  var channel = _ref5.channel,
      url = _ref5.url,
      user = _ref5.user;

  d.stream('profile').push({
    user: profile,
    url: url
  });
  return {
    channel: channel,
    url: url,
    user: R.merge(user, {
      profile: profile
    })
  };
}, [_updateProfile], function (_ref6, user) {
  var channel = _ref6.channel,
      url = _ref6.url;

  return { channel: channel, url: url, user: user };
});

d.stream('save-user-url').flatMap(function (_ref7) {
  var url = _ref7.url,
      key = _ref7.key;

  return storage.setItem("user", userKey(key), url);
}).onError(function (result) {
  return console.error(result);
});

userStream = userStreamData.map(R.prop('user')).filter(R.compose(R.not, R.isNil));

userLoadedStream = userStream.map(function (user) {
  return !!user && !!user.profile;
}).toEventStream();

isMobilePhone = function isMobilePhone(phone) {
  return phone && phone.length >= 9;
};

validateUserProp = R.curry(function (prop, user) {
  switch (prop) {
    case 'name':
      return [validator.isLength(user.profile.name || '', 2, 170), "Please enter your name"];
    case 'email':
      return [validator.isEmail(user.profile.email || ''), "Please enter a valid email address"];
    case 'phone':
      return [isMobilePhone(onlyNumbers(user.profile.phone || '')), "Please enter a valid mobile phone #"];
  }
});

validateUserPropOnLocale = R.curry(function (locale, prop, user) {
  switch (prop) {
    case 'name':
      return [validator.isLength(user.profile.name || '', 2, 170), "user.profile.err.name"];
    case 'email':
      return [validator.isEmail(user.profile.email || ''), "user.profile.err.email"];
    case 'phone':
      return [(locale.isMobilePhone || isMobilePhone)(onlyNumbers(user.profile.phone || '')), "user.profile.err.phone"];
  }
});

userProps = ['name', 'email', 'phone'];

validateUser = function validateUser(user) {
  return R.reduce(function (errors, prop) {
    return R.assoc(prop, validateUserProp(prop, user), errors);
  }, {}, userProps);
};

validateUserOnLocale = R.curry(function (locale, user) {
  return R.reduce(function (errors, prop) {
    return R.assoc(prop, validateUserPropOnLocale(locale, prop, user), errors);
  }, {}, userProps);
});

isUserValid = R.pipe(validateUser, R.values, R.all(R.nth(0)));

isUserValidOnLocale = function isUserValidOnLocale(locale) {
  return R.pipe(validateUserOnLocale(locale), R.values, R.all(R.nth(0)));
};

validate = R.curry(function (stream, prop) {
  return stream.map(validateUserProp(prop)).map(function (_ref8) {
    var _ref9 = _slicedToArray(_ref8, 2),
        valid = _ref9[0],
        error = _ref9[1];

    return R.assoc(prop, !valid ? error : null, {});
  });
});

profileValidationErrors = Bacon.mergeAll(R.map(validate(userStream), userProps));

toError = function toError(errorsStream) {
  return errorsStream.map(R.assoc('server', R.__, {})).mapError(R.assoc('server', R.__, {}));
};

errorsStream = Bacon.mergeAll(toError(userStream.map(R.prop('error'))), toError(_updateProfile.errors()), profileValidationErrors).scan({}, R.merge);

validProfileStream = errorsStream.map(R.values).map(R.filter(R.compose(R.not, R.isNil))).map(R.length).map(R.equals(0)).toEventStream().skipUntil(userLoadedStream).toProperty();

validProfileStream.onValue(function () {});

addressesSvcURL = userStream.map(R.path(['addresses', 'resource_url'])).skipDuplicates(R.equals).toProperty(); // avoid hitting address resource too many times

loadAddresses = addressesSvcURL.flatMap(resUtil.loadResourceFromURL).map(R.prop('available')).map(R.filter(R.pipe(R.propEq('mini', null), R.not)));

defaultPosition = R.defaultTo({
  latitude: 27,
  longitude: 42
});

addressToPosition = R.pipe(R.prop('position'), defaultPosition);

addDistance = R.curry(function (position, address) {
  var distanceInfo;
  distanceInfo = {
    distance: geoStore.distance(position, addressToPosition(address))
  };
  return R.merge(distanceInfo, address);
});

_addAddress = new Bacon.Bus();

addAddressStream = _addAddress.combine(addressesSvcURL, function (data, url) {
  return R.assoc('url', url, data);
}).flatMap(resUtil.createResource).map(R.prop('address'));

reloadAddresses = d.stream('reload-user').flatMap(function () {
  return userStream;
}).map(R.path(['addresses', 'resource_url'])).flatMap(resUtil.loadResourceFromURL).map(R.prop('available')).map(R.filter(R.pipe(R.propEq('mini', null), R.not)));

// availableAddressesStream = Bacon.update null,
//   [d.stream('reload-user')], (prev, _) ->
//     null
//   [loadAddresses, geoStore.currentPosition], (prev, addresses, currentPosition) ->
//     R.sortBy R.prop('distance'), R.map addDistance(currentPosition), addresses
//   [loadAddresses], (prev, addresses) ->
//     addresses
//   [reloadAddresses], (prev, addresses) ->
//     addresses
//   [addAddressStream], (prev, address) ->
//     R.concat [address], R.defaultTo [], prev
availableAddressesStream = Bacon.constant([]);

// hack? - userStream is consumed way before loadAddresses is requested and no event is send on
// subscribing on this channel
availableAddressesStream.onValue(function (addresses) {});

// noop - load addresses upfront
executeAction = function executeAction(action) {};

// browser.navigate action.url.replace "{location}", escape browser.pageURL(true)
channelStream.awaiting(userStream).onValue(resUtil.showLoadingIndicator);

module.exports = {
  user: userStream.toProperty(),
  reload: function reload() {
    setTimeout(function () {
      return d.stream('reload-user').push(new Date());
    }, 0);
    return userStream;
  },
  validProfile: validProfileStream,
  errors: errorsStream,
  addresses: availableAddressesStream.filter(R.compose(R.not, R.isNil)),
  addAddress: function addAddress(data) {
    _addAddress.push(data);
    return addAddressStream;
  },
  executeAction: executeAction,
  updateProfile: function updateProfile(profile) {
    setTimeout(function () {
      return d.stream('save-profile').push(profile);
    }, 0);
    return _updateProfile;
  },
  autoLogin: function autoLogin(params) {
    setTimeout(function () {
      return d.stream('auto-login').push(params);
    }, 0);
    return _autoLogin;
  },
  validateUser: validateUser,
  validateUserOnLocale: validateUserOnLocale,
  isUserValid: isUserValid,
  isUserValidOnLocale: isUserValidOnLocale,
  logout: function logout() {
    return channelStream.map(R.prop('id')).flatMap(function (key) {
      return storage.deleteItem("user", userKey(key));
    });
  }
};

onlyNumbers = function onlyNumbers(str) {
  return str != null ? str.replace(/[^0-9]/g, '') : void 0;
};